import React, { Component } from "react";
import _ from "lodash";
import { gql, graphql, compose } from "react-apollo";
import { withRouter } from "react-router-dom";

import FormPost from "../form-post/FormPost";
import withLoading from "../../modules/loader/withLoading";
import { LOGGED_IN_USER } from "../../pages/HomePage";
import Card from "../../views/Card";
import withAuthen from "../authenticate/withAuthen";

class EditPostContainer extends Component {
  state = {};

  render() {
    const { Post: post } = this.props.data;

    if (post) {
      return (
        <Card title="Edit">
          <FormPost onSave={this.handleSave} value={post} />
        </Card>
      );
    }
    return null;
  }

  handleSave = async value => {
    try {
      const loggedInUser = _.get(this.props, "loggedUserQuery.loggedInUser");
      // redirect if no user is logged in
      if (!loggedInUser) {
        window.M.toast({html: "Only logged in users can create new posts"});
        this.props.history.push("/");
        return;
      }

      const { description, imageId, isPrivate, sendTo, sendURL } = value;
      const authorId = loggedInUser.id;

      await this.props.UpdatePostMutation({
        variables: {
          id: _.get(this.props, "data.Post.id"),
          description,
          imageId,
          authorId,
          isPrivate,
          sendTo,
          sendURL
        }
      });
      this.props.history.push("/");
    } catch (error) {
      window.M.toast({html: "Error: " + error.message})
      console.log(error.name);
      console.log(error.message);
      console.log(error.stack);
    }
  };
}

const POST_QUERY = gql`
  query PostQuery($id: ID) {
    Post(id: $id) {
      id
      isPrivate
      description
      imageId
      author {
        facebookUserId
      }
      sendTo
      sendURL
    }
  }
`;

const UPDATE_POST = gql`
  mutation UpdatePost(
    $id: ID!
    $description: String!
    $imageId: String!
    $isPrivate: Boolean!
    $authorId: ID!
    $sendTo: String!
    $sendURL: String!
  ) {
    updatePost(
      id: $id
      description: $description
      imageId: $imageId
      isPrivate: $isPrivate
      authorId: $authorId
      sendTo: $sendTo
      sendURL: $sendURL
    ) {
      id
    }
  }
`;

export default compose(
  withAuthen,
  graphql(UPDATE_POST, { name: "UpdatePostMutation" }),
  graphql(POST_QUERY, {
    options: ownProps => {
      return {
        variables: {
          id: _.get(ownProps, "params.postId")
        }
      };
    }
  }),
  withLoading
)(withRouter(EditPostContainer));



// WEBPACK FOOTER //
// ./src/templates/edit-post/EditPostContainer.js